import PropTypes from "prop-types";
import {Helmet} from "react-helmet";
import React, {useContext, useEffect, useState} from "react";
import { Row, Col, CardBody, Card, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { AuthContext } from "context/authContext";
import AppConfig from "../../constants/config";

const Login = () => {
  const navigate = useNavigate();
	const { reloadUserData, getProcessingStatus, getProcessingSearch } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [ipAddress, setIPAddress] = useState('')

  const getIPAddress = async() =>{
    const response = await axios.get('https://api.ipify.org?format=json')
    if(response && response.data){
      setIPAddress(response.data.ip)
    }else{
      console.log("Fetching Ip address error")
    }
  }

  useEffect(() => {
    getIPAddress()
  },[])

  const handleSubmit = async(values) => {
    setLoading(true);
    try {
      values.ip = ipAddress
      const {data} = await axios.post(`${AppConfig.baseUrl}/users/login`, values);
      if(!data.error){
        formik.resetForm();
        if(values.clientSelection){
          await localStorage.setItem('temp_token', data.token);
          navigate(`/client_selection`);
        }
        else{
          if(data.is_2fa_active){
            await localStorage.setItem('temp_token', data.token);
            navigate("/factorauth", { state: { key: "login" } });
          }
          else if(!data.terms_checked){
            await localStorage.setItem('temp_token', data.token);
            navigate(`/terms_and_conditions/accept`);
          }
          else{
            await localStorage.setItem('token', data.token);
            await localStorage.setItem('company', data.company.toLowerCase());
            reloadUserData()
            getProcessingStatus()
            getProcessingSearch()
            if(data.is_1st_login){
              navigate("/set_password");
            }
            else{
              toast.success('Logged in Successfully');
              window.location.href = `/${data.company.toLowerCase()}/quickaccess`;
            }
          }
        }
      }
      else{
          throw new Error(data.title);
      }
    } catch (error) {
      toast.error(error.message == 'Network Error' ? 'Maintenance in process' : error.message);
    }
    setLoading(false);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
      clientSelection: false,
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Plese enter valid email").required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: handleSubmit
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>LeaseJava | Login </title>
      </Helmet>
      <div className="account-pages my-5 pt-sm-5 login-mt">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-lbusers bg-softbg-soft-lbusers login-color">
                  <Row>
                    <Col xs={12}>
                      <div className="text-lbusers p-4">
                        <h5 className="text-white login-head">Welcome To LeaseJava User Panel</h5>
                        <p className="text-white">Sign in to continue</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2 mt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={formik.handleSubmit}
                    >

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email || ""}
                          invalid={
                            formik.touched.email && formik.errors.email ? true : false
                          }
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={formik.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.password && formik.errors.password ? true : false
                          }
                        />
                        {formik.touched.password && formik.errors.password ? (
                          <FormFeedback type="invalid">{formik.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Input
                          className="form-check-input"
                          name="clientSelection"
                          id="clientSelection"
                          value={formik.values.clientSelection}
                          type="checkbox"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <Label htmlFor="clientSelection" className="ms-2 form-check-label">Filter your clients</Label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-lbusers login-btn-color btn-block"
                          type="submit"
                          disabled={loading} 
                        >
                            {
                              loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                          LOGIN
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;

Login.propTypes = {
  history: PropTypes.object,
};
